import { render, staticRenderFns } from "./DrivewealthDisclosures.vue?vue&type=template&id=0a511979&scoped=true"
import script from "./DrivewealthDisclosures.vue?vue&type=script&lang=ts"
export * from "./DrivewealthDisclosures.vue?vue&type=script&lang=ts"
import style0 from "./DrivewealthDisclosures.vue?vue&type=style&index=0&id=0a511979&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a511979",
  null
  
)

export default component.exports